import { Box } from "@mui/material";
import HeadquarterWiseSalesDesktop from "../components/desktop/headquarter-wise-sales/HeadquarterWiseSalesDesktop";

const HeadquarterWiseSales = () => {
  return (
    <Box padding={2}>
      <HeadquarterWiseSalesDesktop />
    </Box>
  );
};

export default HeadquarterWiseSales;
